<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-flex xs12 md44 class="my-3">

      <div class="text-xs-center">
        <h2 class="headline">プライバシーポリシー</h2>

      </div>


<div class="mb-5">
<p>
当社は、個人情報の重要性を認識し、個人情報保護法に則った運営を行っており、以下の取り組みを実施いたしております。
</p>
<p>
１. 当社は、お客様個人に関する情報（以下「個人情報」といいます。）の取扱いについて管理責任者を置き、その管理責任者に適切な管理を行わせております。<br>
</p>
<p>
    個人情報管理責任者<br>
    Active Force 代表 高橋 旭<br>
    E-mail：info@ac4th.com
</p>
<p>
２. お客様から、お客様の個人情報を取得させていただく場合は、その利用の目的を出来る限り特定するとともに、お客様に対する当社の窓口等をあらかじめ明示したうえで、必要な範囲の個人情報を取得させていただきます。
</p>
<p>
３. 当社は、お客様より取得させていただいた個人情報を適切に管理し、お客様の事前承認なくお客様の同意を得た会社以外の第三者に提供、開示等一切いたしません。ただし、次の場合はこの限りではありません。<br>
</p>
<p>
１) 法令に基づく場合<br>
２) 人の生命、身体または財産の保護のために必要がある場合で、お客様本人の同意を得ることが困難であるとき<br>
３) 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合で、お客様本人の同意を得ることが困難であるとき<br>
４) 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合で、お客様本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき<br>
</p>

<p>
４. 当社が、上記 3．におけるお客様の同意に基づき個人情報を提供する会社には、お客様の個人情報についての秘密保持、安全管理等についての契約を締結して、適切な監督を行います。
</p>
<p>
５. 当社は、お客様に有益と思われる当社のサービス、又は提携先の商品、サービス等の情報を、電子メール、郵便、電話等によりお客様に連絡させ ていただく場合がございます。お客様は、当社が別途定める方法にてお申し出いただくことにより、これらの取扱いを中止させたり、再開させたりすることがで きます。
</p>
<p>
６. 当サイトからリンクされている第三者企業が、サービスあるいは懸賞や販売促進活動を通じてお客様の情報を収集することがあります。当社は、これらの第三者企業におけるお客様の個人情報の保護について、いかなる義務や責任も負いませんので予めご了承ください。
</p>
<p>
７. 当ポリシーに重要な変更がある場合には、サイト上で告知します。 その他の変更については、お客様ご自身が変更点に関しての最新の情報を、当サイト上で随時確認されることを推奨します。確認をされていなかったことに起因 するトラブルに関しては、当社は一切責任を負いかねますので予めご了承下さい。
</p>
<p>
８. お客様からご提供いただいた個人情報に関して、訂正、修正等を要望される場合は、当社各窓口にご請求下さい。個人情報漏洩防止の観点から、 当該ご請求がお客様ご本人によるものであることが確認できた場合に限り、合理的な期間内に、お客様の個人情報を開示、訂正または削除致します。
</p>
<p>
９. 当社は、当社が保有する個人情報に関して適用される法令、規範を遵守するとともに、上記各項における取り組みを適宜見直し、改善していきます。
</p>
<p>
１０. 当プライバシーポリシーに関するお問い合わせは、下記担当までお願い致します。
</p>
<p>
〒161-0022 <br>
東京都豊島区南池袋2-8-17<br>
第一豊南ビル6階<br>
Active Force　プライバシー管理担当 <br>
E-mail：info@ac4th.com<br>
</p>
<p>
・Cookie（クッキー）について
</p>
<p>
当サイトは、クッキーを使用することがあります。当社は、主として下記の目的でクッキーを利用します。
</p>
<p>
・お客様の利用状況調査のため<br>
・お客様が会員制サービスを利用される際、毎回パスワードを入力しなくてもすむようにするため<br>
・お客様がより満足いただけるようサイトを改良したり、個々のお客様に合わせてカスタマイズしたりするため<br>
・お客様の関心事に合わせて有益なサービスや広告を提供するため<br>
・統計分析を行うため<br>
</p>
<p>
お客様は、ブラウザの設定により、クッキーの受け取りを拒否したり、クッキーを受け取ったとき警告を表示させたりできます。但し、当サイトのサービスに は、クッキーなしではサービス内容に制限が発生することや、利用できない場合もありますので、あらかじめご了承ください。
</p>
</div>
    </v-flex>




    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
export default {
  data () {
    return {
    }
  }
}

</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue